var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDietFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0h2v7h-2V0zM1 11h22a1 1 0 011 1 12.029 12.029 0 01-7.021 10.909 1 1 0 01-.416.091H7.437a1 1 0 01-.416-.091A12.029 12.029 0 010 12a1 1 0 011-1zM7 2H5v7h2V2zM17 2h2v7h-2V2z"
  })));
}
export default SvgDietFilled;